import { MENU_OBJECT_TYPES } from 'constants/menuManagement';

/* POS sync-in-place menus are read-only except for the merchant-owned marketing copy
(CN-50652): descriptions on main items and modifiers, plus imagery on main items. The
backend tracks these as field-level user overrides (CN-49731) so they survive a resync.
Values are the `dataIndex` keys from menuManagementColumns' drawerEditConfig - `itemPhoto` is
the upload/thumbnail field, and is how imagery is edited: the drawer form no longer renders a
raw `imageUrl` input at all. That coupling is stringly-typed,
so posSyncEditableFields.test.ts asserts every key below still exists in that config; a renamed
column would otherwise silently unlock the field instead of failing. A Map keeps a garbage
`itemType` off the Object prototype chain ('constructor', 'toString', ...).

When adding a drawer field, note PosSyncLockedField's constraint: it neutralizes locked fields
via `fieldset disabled`, which only covers native form controls. A field built on an Anchor, a
Chip, or a tabIndex'd div would stay reachable inside a locked wrapper. */
export const POS_SYNC_EDITABLE_FIELDS = new Map<string, ReadonlySet<string>>([
  [MENU_OBJECT_TYPES.items, new Set(['description', 'itemPhoto'])],
  [MENU_OBJECT_TYPES.modifiers, new Set(['description'])],
]);

// Whether this entity type opens a partially editable drawer at all under POS sync.
export function isPosSyncEditableType(itemType?: string): boolean {
  return !!itemType && POS_SYNC_EDITABLE_FIELDS.has(itemType);
}

export function isPosSyncEditableField({
  itemType,
  dataIndex,
}: {
  itemType?: string;
  dataIndex?: string;
}): boolean {
  if (!itemType || !dataIndex) return false;
  return POS_SYNC_EDITABLE_FIELDS.get(itemType)?.has(dataIndex) ?? false;
}
